function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-266 -374)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 52,
  height: 52,
  fill: "#feefe8",
  rx: 4,
  transform: "translate(266 374)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0H36V36H0z",
  transform: "translate(274 382)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f26524",
  d: "M24399.43-5475.1a.5.5 0 0 1-.4-.3.482.482 0 0 1 .1-.5l13.982-15.511 6.689-7.409a.486.486 0 0 1 .7-.049l2.3 2.051c.1.052.152.2.2.354a.54.54 0 0 1-.15.35l-6.391 7.056 1.895 1.75a.452.452 0 0 1 .152.35.529.529 0 0 1-.152.35l-5.891 6.506a15.191 15.191 0 0 1-5.492 3.906h6.793a.471.471 0 0 1 .5.5.473.473 0 0 1-.5.5h-10.24a13.9 13.9 0 0 1-2.5.2c-.548-.004-1.097-.057-1.595-.104zm19.375-.1a.474.474 0 0 1-.5-.5.472.472 0 0 1 .5-.5h1.246a.5.5 0 0 1 .5.5.474.474 0 0 1-.5.5zm-2.949 0a.474.474 0 0 1-.5-.5.472.472 0 0 1 .5-.5h1.25a.473.473 0 0 1 .5.5.475.475 0 0 1-.5.5z",
  transform: "translate(274 382) translate(-24392.996 5505.001)"
})));

function SvgFlow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlow);
export default __webpack_public_path__ + "static/media/flow.100e2cde.svg";
export { ForwardRef as ReactComponent };